import React from 'react';
import { Timeline } from 'react-gsap';
import '../styles/burger.scss'
import { Link } from "gatsby"
import burgerStyles from '../styles/burger.module.scss'
import headerStyles from '../styles/header.module.scss'
import { css } from "@emotion/core"
 
const toggleMenuClasses = () => {
  let hamburgerIcon = document.getElementById('burger');
  hamburgerIcon.classList.toggle('open');
  let menuUl = document.getElementById('menu_ul');
  menuUl.classList.toggle('activeul');
  let menuSlide = document.getElementById('menu');
  menuSlide.classList.toggle('active');
}
 
const Burger = () => (
  <Timeline
    target={
      
      <div className='nav_icon' id='burger' onClick={toggleMenuClasses}> 
          <div className='bar half start'></div>
          <div className='bar'></div>
          <div className='bar half end'></div>
      </div>

    }
  >
    
    <nav className='menu' id='menu'>
      <div className='menu_main'>
        <ul id='menu_ul'>
          <li>
            <Link to='/' className={burgerStyles.nav_item} activeClassName={burgerStyles.nav_item_active}>Inicio</Link>
            <span className='line'></span>
            <span className='number'>01</span>
          </li>

          <li>
            <Link to='/sobre-mi' className={burgerStyles.nav_item} activeClassName={burgerStyles.nav_item_active}>¿Quién soy?</Link>
            <span className='line'></span>
            <span className='number'>02</span>
          </li>

          <li>
            <Link to='/diseno-web-sevilla' className={burgerStyles.nav_item} activeClassName={burgerStyles.nav_item_active}>Diseño web</Link>
            <span className='line'></span>
            <span className='number'>03</span>
          </li>

          <li>
            <Link to='/diseno-tienda-online-sevilla' className={burgerStyles.nav_item} activeClassName={burgerStyles.nav_item_active}>Tiendas online</Link>
            <span className='line'></span>
            <span className='number'>04</span>
          </li>

          <li>
            <Link to='/portfolio' className={burgerStyles.nav_item} activeClassName={burgerStyles.nav_item_active}>Portfolio</Link>
            <span className='line'></span>
            <span className='number'>05</span>
          </li>

          <li>
            <Link to='/blog' className={burgerStyles.nav_item} activeClassName={burgerStyles.nav_item_active}>Blog</Link>
            <span className='line'></span>
            <span className='number'>06</span>
          </li>
        </ul>

        <div className={burgerStyles.btn_presupuesto}>
          <Link className={burgerStyles.nav_item_btn} activeClassName={burgerStyles.nav_item_active} to="/contacto"><span css={css`text-transform: uppercase; font-weight:600; letter-spacing:2px;`}>Solicita presupuesto gratis</span></Link>
        </div>
        
      </div>
    </nav>
  </Timeline>

  
);


export default Burger